import { trpc, TrpcOutputs } from '../../config/trpc';

export type AppliedDraft = TrpcOutputs['getAppliedDraftsByQuote'][0];

export const useAppliedDraftsByQuote = (quoteId: number | undefined, isEnabled: boolean) => {
  const { data } = trpc.getAppliedDraftsByQuote.useQuery(
    { quoteId: quoteId as number },
    { enabled: isEnabled && !!quoteId },
  );
  return data;
};
